var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _use, _use2, _use3, _use4, _path42, _g, _use5, _use6, _g2, _g3, _g4, _use7, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _use8, _path54, _path55, _path56, _use9, _use0, _use1, _path57, _path58, _path59, _path60, _path61, _use10, _path62, _use11, _use12, _use13, _use14, _path63, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _path64, _use29, _use30, _use31, _use32, _use33, _use34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    height: 400,
    width: 600,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1339",
    fill: "#f00",
    d: "m240 400h360v-400h-360v294.61 105.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1341",
    fill: "#060",
    d: "m0 400h240v-400h-240v400z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1343",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m318.24 262.04c-30.21-0.91-168.74-87.38-169.69-101.15l7.6496-12.757c13.741 19.966 155.36 104.06 169.27 101.08l-7.2299 12.823"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1345",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m154.59 146.4c-2.7092 7.2937 36.15 31.318 82.903 59.754s87.065 46.006 90.053 43.486c0.18168-0.32544 1.4701-2.5409 1.352-2.5224-0.5609 0.8449-1.9243 1.1095-4.0515 0.49653-12.63-3.6433-45.575-18.763-86.374-43.506-40.798-24.743-76.294-47.542-81.812-57.232-0.38274-0.67116-0.65702-1.8944-0.60057-2.8469h-0.13494l-1.1756 2.0514-0.1605 0.32191 0.00088-0.002zm164.36 116.03c-0.51327 0.92957-1.4675 0.9622-3.2825 0.76112-11.3-1.2506-45.589-17.925-86.161-42.213-47.212-28.262-86.204-54.011-81.968-60.744l1.1509-2.0346 0.22665 0.0706c-3.8037 11.405 76.948 57.576 81.702 60.522 46.724 28.947 86.114 45.851 89.601 41.457l-1.2682 2.181"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1347",
    strokeLinejoin: "round",
    d: "m154.59 146.4c-2.7101 7.2937 36.149 31.318 82.903 59.754 46.752 28.434 87.065 46.006 90.053 43.486 0.18256-0.32544 1.4701-2.5409 1.352-2.5232-0.56001 0.84402-1.9234 1.1104-4.0506 0.49741-12.631-3.6433-45.575-18.765-86.374-43.506-40.798-24.743-76.294-47.544-81.811-57.232-0.38363-0.67116-0.65702-1.8962-0.60146-2.8487l-0.13405-0.002-1.1747 2.0532-0.16139 0.32191h-0.00088zm164.36 116.04c-0.51238 0.92957-1.4675 0.96044-3.2816 0.76112-11.3-1.2506-45.589-17.925-86.162-42.213-47.21-28.26-86.2-54.01-81.97-60.74l1.1509-2.0346 0.22665 0.0706c-3.8037 11.405 76.948 57.578 81.702 60.522 46.724 28.947 86.115 45.851 89.601 41.458l-1.2682 2.181v-0.002z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57293,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path1349",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m240.17 169.23c30.237-0.23901 67.55-4.1319 89.023-12.69l-4.6265-7.5168c-12.692 7.0247-50.21 11.644-84.652 12.335-40.736-0.37483-69.49-4.1681-83.897-13.835l-4.3672 8.0045c26.484 11.207 53.623 13.587 88.52 13.703"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path1351",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m330.44 156.71c-0.73904 1.1818-14.744 6.0096-35.374 9.5735-13.987 2.1325-32.234 3.9555-55.004 3.9776-21.633 0.0203-39.305-1.5196-52.685-3.3329-21.656-3.3955-32.833-8.1201-36.966-9.7878 0.3951-0.78582 0.64909-1.3388 1.0301-2.0726 11.895 4.7378 23.124 7.5936 36.279 9.6176 13.291 1.8 30.75 3.362 52.277 3.3399 22.664-0.0212 40.709-1.9826 54.616-4.0517 21.155-3.414 32.711-7.8052 34.334-9.8443l1.494 2.5788v0.002zm-4.0621-7.6244c-2.293 1.8415-13.718 5.8932-33.819 9.1034-13.415 1.9244-30.472 3.6451-52.265 3.6662-20.704 0.0203-37.619-1.375-50.486-3.2508-20.414-2.6644-31.278-7.4736-35.197-8.8759 0.3898-0.67381 0.78666-1.3441 1.1941-2.0152 3.0488 1.5346 13.534 5.7926 34.227 8.7242 12.721 1.8018 29.66 3.1459 50.262 3.1247 21.69-0.0203 38.553-1.7762 51.883-3.6865 20.205-2.7799 31.077-7.9472 32.728-9.2428l1.4728 2.4527"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path1353",
    strokeLinejoin: "round",
    d: "m330.44 156.71c-0.73904 1.1818-14.743 6.0113-35.373 9.5753-13.988 2.1325-32.234 3.9555-55.004 3.9776-21.633 0.0203-39.305-1.5196-52.684-3.3329-21.656-3.3955-32.833-8.1201-36.965-9.7896 0.39509-0.78581 0.64908-1.337 1.0301-2.0708 11.895 4.736 23.124 7.5918 36.279 9.6158 13.291 1.8 30.75 3.362 52.276 3.3417 22.664-0.0229 40.709-1.9844 54.616-4.0534 21.155-3.4122 32.711-7.8034 34.334-9.8425l1.494 2.5788h-0.002zm-4.0603-7.6226c-2.293 1.8415-13.718 5.8932-33.819 9.1034-13.415 1.9226-30.472 3.6433-52.265 3.6645-20.704 0.0203-37.619-1.375-50.485-3.2491-20.414-2.6661-31.279-7.4754-35.196-8.8776 0.3898-0.67381 0.78666-1.3423 1.1941-2.0135 3.0479 1.5346 13.533 5.7909 34.226 8.7224 12.72 1.8036 29.661 3.1477 50.262 3.1265 21.69-0.0221 38.553-1.7762 51.883-3.6883 20.205-2.7799 31.077-7.9472 32.728-9.241l1.4728 2.4509v0.002z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57316,
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path1355",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m140.88 205.66c18.598 10.003 59.905 15.044 98.994 15.391 35.591 0.0564 81.958-5.5016 99.297-14.69l-0.47712-10.012c-5.4246 8.4773-55.113 16.609-99.206 16.276-44.093-0.3325-85.038-7.1429-98.687-15.959l0.0794 8.9914"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "path1357",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m340.12 204.22 0.00088 2.3892c-2.606 3.1142-18.946 7.8237-39.436 11.14-15.596 2.391-35.928 4.1945-61.262 4.1945-24.069 0-43.262-1.7145-58.148-4.0014-23.528-3.4246-38.579-9.4245-41.6-11.216l0.0132-2.7834c9.0748 6.0316 33.661 10.445 41.917 11.796 14.788 2.2719 33.868 3.9749 57.817 3.9749 25.216 0 45.434-1.793 60.931-4.1681 14.701-2.1237 35.644-7.6465 39.767-11.324v-0.002zm0.01-8.4922 0.00088 2.3892c-2.606 3.1142-18.946 7.8237-39.436 11.14-15.596 2.391-35.928 4.1945-61.262 4.1945-24.069 0-43.263-1.7145-58.148-4.0014-23.528-3.4246-38.579-9.4245-41.6-11.217l0.0123-2.7834c9.0757 6.0325 33.661 10.447 41.917 11.796 14.788 2.2719 33.868 3.9758 57.817 3.9758 25.216 0 45.434-1.7921 60.932-4.169 14.701-2.1237 35.644-7.6465 39.767-11.324"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "path1359",
    strokeLinejoin: "round",
    d: "m340.12 204.22 0.00088 2.3874c-2.606 3.1159-18.946 7.8255-39.437 11.142-15.595 2.391-35.927 4.1945-61.262 4.1945-24.069 0-43.263-1.7163-58.148-4.0014-23.529-3.4264-38.579-9.4262-41.6-11.217l0.0132-2.7852c9.0748 6.0334 33.661 10.447 41.917 11.798 14.788 2.2701 33.868 3.9732 57.817 3.9732 25.216 0 45.434-1.7912 60.931-4.1663 14.701-2.1237 35.644-7.6465 39.767-11.324h0.00088zm0.01-8.4922 0.00088 2.3874c-2.606 3.1142-18.946 7.8237-39.437 11.14-15.595 2.391-35.927 4.1945-61.262 4.1945-24.069 0-43.263-1.7145-58.148-4.0014-23.529-3.4246-38.579-9.4245-41.6-11.216l0.0132-2.7852c9.0748 6.0325 33.661 10.447 41.917 11.796 14.788 2.2719 33.868 3.9758 57.817 3.9758 25.216 0 45.434-1.7921 60.931-4.169 14.701-2.1237 35.644-7.6465 39.767-11.324l0.00088 0.002z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57282,
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path1361",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m239.79 260.32c-42.772-0.25489-79.421-11.659-87.16-13.544l5.6433 8.8344c13.67 5.7503 49.424 14.32 81.927 13.371 32.504-0.94809 60.91-3.466 80.928-13.211l5.7862-9.1555c-13.642 6.425-60.068 13.639-87.125 13.705"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path1363",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m323.3 253.72c-0.85016 1.2973-1.7171 2.5806-2.5972 3.8294-9.4417 3.3276-24.319 6.8227-30.597 7.8422-12.823 2.6441-32.664 4.5958-50.273 4.6046-37.889-0.55475-68.905-7.9737-83.496-14.301l-1.1773-2.0241 0.19313-0.30427 1.9966 0.77435c25.948 9.2816 55.091 12.985 82.697 13.652 17.538 0.0617 35.095-2.01 49.291-4.5491 21.772-4.3621 30.575-7.65 33.276-9.1405l0.68613-0.38541v0.002zm5.0163-8.277c0.022 0.0256 0.0441 0.052 0.0653 0.0776-0.63585 1.0733-1.2911 2.1652-1.9622 3.2623-5.0366 1.8018-18.703 5.7997-38.659 8.591-13.149 1.7895-21.322 3.5242-47.479 4.034-49.016-1.2471-80.751-10.832-88.289-13.197l-1.1174-2.1414c28.406 7.4154 57.421 12.592 89.408 13.121 23.931-0.50977 34.111-2.2719 47.15-4.0481 23.271-3.6204 34.996-7.4516 38.516-8.5575-0.045-0.0635-0.097-0.13053-0.15521-0.19844l2.5231-0.94192"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path1365",
    strokeLinejoin: "round",
    d: "m323.3 253.72c-0.85016 1.2991-1.7171 2.5823-2.5963 3.8294-9.4417 3.3293-24.319 6.8245-30.597 7.844-12.824 2.6423-32.665 4.594-50.274 4.6029-37.89-0.55474-68.905-7.9719-83.496-14.299l-1.1773-2.0241 0.19225-0.30427 1.9966 0.77435c25.948 9.2834 55.091 12.987 82.698 13.652 17.538 0.0617 35.095-2.01 49.292-4.5491 21.771-4.3621 30.574-7.65 33.275-9.1405l0.68701-0.38541h-0.00088zm5.0172-8.2753c0.022 0.0256 0.0441 0.0503 0.0653 0.0776-0.63585 1.0733-1.2911 2.1652-1.9622 3.2623-5.0357 1.8-18.702 5.7988-38.659 8.5893-13.149 1.7912-21.322 3.526-47.479 4.034-49.015-1.2471-80.75-10.831-88.289-13.195l-1.1174-2.1431c28.406 7.4154 57.422 12.592 89.408 13.121 23.931-0.50976 34.112-2.2719 47.152-4.0499 23.271-3.6186 34.996-7.4498 38.515-8.5558-0.0441-0.0635-0.0961-0.13053-0.15433-0.19932l2.5231-0.9428-0.002 0.002z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.54985,
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path3966",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m328.83 197.76c0.13873 28.137-14.26 53.386-25.858 64.525-16.408 15.759-38.163 25.896-63.569 26.363-28.37 0.52117-55.12-17.974-62.295-26.099-14.028-15.885-25.449-36.057-25.815-63.243 1.7376-30.709 13.793-52.1 31.268-66.769s40.743-21.813 60.121-21.302c22.358 0.59003 48.475 11.558 66.521 33.332 11.823 14.266 16.943 29.748 19.627 53.193zm-89.186-96.342c54.485 0 99.296 44.338 99.296 98.703 0 54.364-44.811 98.704-99.296 98.704s-98.924-44.339-98.924-98.704 44.439-98.703 98.924-98.703"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path1371",
    strokeLinejoin: "round",
    d: "m239.91 101.08c54.534 0 99.011 44.483 99.011 99.022 0 54.538-44.478 99.02-99.011 99.02-54.534 0-99.011-44.481-99.011-99.02s44.478-99.022 99.011-99.022zm0 2.1784c53.096 0 96.833 43.582 96.833 96.844 0 53.26-43.736 96.842-96.833 96.842-53.096 0-96.832-43.582-96.832-96.842s43.736-96.844 96.832-96.844z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57282,
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path1375",
    strokeLinejoin: "round",
    d: "m239.99 109.31c49.731 0 90.693 40.821 90.693 90.704 0 49.884-40.963 90.703-90.693 90.703s-90.693-40.819-90.693-90.703c0-49.883 40.964-90.704 90.693-90.704zm0 2.1784c48.537 0 88.515 39.839 88.515 88.525 0 48.685-39.979 88.524-88.515 88.524s-88.515-39.839-88.515-88.524c0-48.686 39.979-88.525 88.515-88.525z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57282,
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path1377",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m243.12 99.531v1.0938h-6.25v-1.0625h-2.1562v201.22h2.1562v-0.9375h6.2812v0.96875h2.1562l-0.0312-201.28h-2.1562z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path1379",
    strokeLinejoin: "round",
    d: "m237.02 100.68h6.019",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57282,
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path1381",
    strokeLinejoin: "round",
    d: "m237.03 299.64h6.0481",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57282,
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path1385",
    strokeLinejoin: "round",
    d: "m243.13 99.546h2.1598l0.0185 201.25h-2.1616l-0.0159-201.25h-0.00088zm-8.4213 0.0018h2.1766l0.003 201.25h-2.1783v-201.25h-0.00088z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57296,
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path1387",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m140.54 195.88c12.416-11.431 58.227-18.843 98.872-18.65 40.645 0.19138 88.781 8.5425 99.252 18.407l0.10495 8.5249c-8.7697-8.2488-46.167-18.086-99.277-18.196-53.111-0.11025-91.672 9.9977-98.954 18.417l0.002-8.502"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path1389",
    strokeLinejoin: "round",
    d: "m140.52 196.28v7.3572",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57243,
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path1391",
    strokeLinejoin: "round",
    d: "m338.99 196.58v7.3554",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57243,
    fill: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path1393",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m239.95 184.77c23.383-0.0432 46.069 2.2172 64.065 5.7194 18.569 3.7139 31.637 8.3573 36.104 13.573l-0.005 2.5806c-5.3884-6.4885-22.973-11.247-36.518-13.966-17.859-3.4757-40.394-5.7185-63.647-5.6736-24.538 0.0441-47.387 2.3698-64.984 5.8014-14.12 2.8019-32.952 8.3696-35.303 13.858v-2.689c1.292-3.7985 15.313-9.4792 34.985-13.417 17.728-3.4572 40.62-5.7397 65.302-5.7864h0.00089zm0.01-8.4922c23.383-0.0423 46.069 2.2172 64.065 5.7194 18.569 3.7139 31.637 8.3573 36.104 13.573l-0.005 2.5806c-5.3884-6.4885-22.973-11.247-36.518-13.966-17.859-3.4757-40.394-5.7185-63.647-5.6736-24.538 0.0441-47.277 2.3698-64.875 5.8014-13.626 2.5832-33.227 8.3696-35.412 13.858v-2.689c1.292-3.7588 15.597-9.6414 34.986-13.417 17.728-3.4572 40.62-5.7397 65.302-5.7864"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path1395",
    strokeLinejoin: "round",
    d: "m239.95 184.77c23.383-0.0432 46.07 2.2154 64.065 5.7194 18.569 3.7121 31.637 8.3556 36.105 13.571l-0.005 2.5823c-5.3884-6.4902-22.973-11.248-36.518-13.968-17.858-3.474-40.393-5.7168-63.647-5.6736-24.538 0.0459-47.387 2.3698-64.984 5.8032-14.12 2.8019-32.951 8.3679-35.302 13.858v-2.689c1.2911-3.8003 15.313-9.4792 34.984-13.417 17.729-3.4572 40.62-5.7415 65.302-5.7864zm0.01-8.4922c23.383-0.0423 46.07 2.2172 64.065 5.7194 18.569 3.7139 31.637 8.3556 36.105 13.571l-0.005 2.5823c-5.3884-6.4885-22.973-11.247-36.518-13.966-17.858-3.4757-40.393-5.7185-63.647-5.6736-24.538 0.0441-47.276 2.3698-64.875 5.8014-13.626 2.5832-33.226 8.3696-35.412 13.86v-2.6908c1.2911-3.7588 15.597-9.6414 34.985-13.417 17.729-3.4572 40.62-5.7397 65.302-5.7864z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57282,
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path1397",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m239.48 132.96c36.849-0.18433 68.99 5.1523 83.695 12.685l5.3638 9.279c-12.781-6.888-47.456-14.05-89.005-12.979-33.854 0.20814-70.027 3.7271-88.176 13.41l6.4035-10.709c14.895-7.7241 50.022-11.643 81.72-11.684"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path1399",
    strokeLinejoin: "round",
    d: "m324.11 147.15 3.6502 5.8605",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57409,
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path1401",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m239.97 140.62c21.017-0.0573 41.326 1.1298 57.477 4.0437 15.041 2.7993 29.385 6.9991 31.435 9.2622l1.5892 2.8099c-4.9881-3.257-17.4-6.8836-33.339-9.906-16.007-3.0083-36.301-4.0049-57.201-3.9502-23.722-0.0811-42.152 1.1695-57.969 3.9273-16.727 3.1318-28.333 7.6015-31.197 9.727l1.5592-2.9695c5.5631-2.8381 14.39-6.2592 29.223-8.9297 16.357-2.988 34.983-3.8858 58.423-4.0146h0.00088zm-0.009-8.4826c20.114-0.0547 39.972 1.0663 55.452 3.8506 12.209 2.3751 24.283 6.0872 28.703 9.3874l2.3256 3.6971c-3.9527-4.3965-18.836-8.5602-31.974-10.892-15.362-2.6494-34.396-3.698-54.508-3.8656-21.108 0.0573-40.615 1.3503-55.752 4.1081-14.442 2.7481-23.76 6.0016-27.703 8.5408l2.0451-3.0868c5.4414-2.8646 14.232-5.4954 25.303-7.6447 15.25-2.7764 34.877-4.0376 56.108-4.0949"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path1403",
    strokeLinejoin: "round",
    d: "m239.97 140.62c21.017-0.0556 41.325 1.1298 57.476 4.0437 15.041 2.7993 29.385 7.0009 31.436 9.2604l1.5901 2.8099c-4.9881-3.257-17.401-6.8836-33.339-9.906-16.006-3.0083-36.3-4.0049-57.2-3.9502-23.722-0.0811-42.152 1.1712-57.969 3.9291-16.728 3.13-28.334 7.6015-31.197 9.7261l1.5583-2.9704c5.5631-2.8381 14.39-6.2592 29.223-8.9297 16.357-2.988 34.983-3.8841 58.423-4.0128h-0.00088zm-0.009-8.4843c20.113-0.0529 39.972 1.068 55.452 3.8506 12.209 2.3768 24.283 6.0872 28.704 9.3892l2.3256 3.6954c-3.9536-4.3947-18.836-8.5593-31.974-10.892-15.361-2.6494-34.395-3.698-54.508-3.8656-21.108 0.0591-40.615 1.352-55.752 4.1081-14.441 2.7481-23.76 6.0016-27.703 8.5425l2.0451-3.0868c5.4414-2.8646 14.232-5.4954 25.303-7.6465 15.249-2.7764 34.876-4.0358 56.108-4.0949z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57316,
    fill: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path1405",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m289.15 241.26c-18.218-3.4008-36.469-3.8947-49.217-3.7447-61.407 0.71967-81.244 12.609-83.665 16.209l-4.5894-7.4815c15.634-11.332 49.073-17.687 88.587-17.037 20.518 0.33602 38.224 1.6986 53.119 4.5835l-4.2358 7.4727"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path1407",
    strokeLinejoin: "round",
    d: "m152.7 247.28 3.0126 5.1867",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57282,
    fill: "none"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path1409",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m239.58 236.46c17.082 0.25488 33.85 0.96044 50.033 3.9784l-1.172 2.069c-15.031-2.7746-31.055-3.8365-48.803-3.7518-22.662-0.1755-45.585 1.9412-65.541 7.6685-6.2968 1.7507-16.721 5.8006-17.785 9.1458l-1.165-1.9244c0.33513-1.9773 6.6364-6.0792 18.413-9.3883 22.858-6.5458 44.239-7.6491 66.019-7.799l-0.00088 0.002zm0.77519-8.5963c17.698 0.33073 35.975 1.1492 53.74 4.6681l-1.2206 2.1555c-16.041-3.1856-31.369-4.2466-52.414-4.5702-22.735 0.0397-46.85 1.6625-68.778 8.0372-7.0791 2.062-19.297 6.5202-19.705 10.048l-1.165-2.0655c0.26457-3.2059 10.842-7.388 20.358-10.156 22.096-6.4241 46.275-8.076 69.186-8.1174"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path1411",
    strokeLinejoin: "round",
    d: "m239.58 236.46c17.082 0.25488 33.849 0.96044 50.033 3.9784l-1.172 2.069c-15.031-2.7746-31.055-3.8365-48.803-3.75-22.663-0.17727-45.585 1.9394-65.541 7.6668-6.2968 1.7524-16.721 5.8006-17.784 9.1458l-1.1659-1.9226c0.33601-1.9773 6.6363-6.081 18.414-9.3901 22.858-6.5458 44.239-7.6491 66.019-7.799v0.002zm0.77519-8.5963c17.698 0.33073 35.975 1.1492 53.74 4.6681l-1.2206 2.1537c-16.042-3.1847-31.369-4.2466-52.415-4.5702-22.735 0.0414-46.851 1.6625-68.778 8.0372-7.0791 2.062-19.297 6.5202-19.704 10.05l-1.1659-2.0655c0.26545-3.2059 10.842-7.388 20.358-10.156 22.096-6.4241 46.275-8.076 69.186-8.1174z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.54985,
    fill: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path1419",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m156.9 144.52c30.419-0.39511 170.91 85.849 171.32 101.73l-8.7035 13.341c-3.93-18.44-146.48-102.37-170-100.78l7.3789-14.29"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path1421",
    strokeLinejoin: "round",
    d: "m327.58 247.38-7.3789 11.449",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57298,
    fill: "none"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "path1423",
    strokeLinejoin: "round",
    d: "m156.67 145.27-6.86 12.72",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.57298,
    fill: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "path1425",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m148.65 158.3c5.6468-3.8294 47.139 14.654 90.555 40.832 43.301 26.254 84.678 55.921 80.943 61.475l-1.2294 1.9306-0.56354 0.44626c0.12083-0.0882 0.74345-0.84755-0.0609-2.906-1.8449-6.0704-31.195-29.491-79.894-58.895-47.475-28.31-87.041-45.371-90.997-40.495l1.247-2.3874h-0.00089zm180.44 88.925c3.57-7.0503-34.916-36.044-82.632-64.272-48.813-27.664-83.994-43.951-90.42-39.095l-1.4287 2.5973c-0.0115 0.14463 0.052-0.17551 0.35364-0.41011 1.1694-1.0195 3.1052-0.95074 3.9792-0.96661 11.066 0.16581 42.668 14.709 87.005 40.128 19.428 11.316 82.071 51.491 81.833 62.789 0.0168 0.97102 0.0802 1.1695-0.28574 1.6501l1.5936-2.4218"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "path1427",
    strokeLinejoin: "round",
    d: "m148.65 158.29c5.646-3.8294 47.139 14.655 90.555 40.834 43.301 26.254 84.677 55.921 80.942 61.473l-1.2285 1.9323-0.56354 0.4445c0.12083-0.0864 0.74345-0.84755-0.0609-2.906-1.8449-6.0704-31.195-29.491-79.894-58.895-47.475-28.309-87.041-45.371-90.997-40.494l1.247-2.3892h-0.00089zm180.44 88.927c3.57-7.052-34.916-36.044-82.632-64.272-48.813-27.666-83.994-43.951-90.42-39.095l-1.4278 2.5991c-0.0124 0.14287 0.052-0.17727 0.35364-0.4101 1.1685-1.0195 3.1052-0.95074 3.9792-0.96662 11.065 0.16581 42.667 14.709 87.006 40.128 19.428 11.315 82.071 51.491 81.832 62.789 0.0168 0.97102 0.0803 1.1712-0.28485 1.6519l1.5936-2.4236v-0.002z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.573,
    fill: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path1429",
    fillRule: "evenodd",
    fill: "#fff",
    d: "m180.6 211.01c0 16.27 6.6628 30.987 17.458 41.742 10.816 10.778 25.513 17.579 41.809 17.579 16.381 0 31.247-6.6525 42.016-17.389 10.769-10.735 17.444-25.551 17.446-41.878h-0.00088v-79.189l-118.74-0.14111 0.0123 79.276"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path1431",
    d: "m180.6 211.01c0 16.271 6.6628 30.987 17.457 41.742 10.815 10.778 25.512 17.579 41.809 17.579 16.381 0 31.247-6.6525 42.016-17.389 10.769-10.735 17.443-25.552 17.446-41.88h-0.002v-79.189l-118.74-0.14111 0.0123 79.278h0.002z",
    stroke: "#000",
    strokeWidth: 0.67037,
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path1433",
    d: "m182.82 211.12v0.045c0 15.557 6.4423 29.724 16.776 40.009 10.354 10.305 24.614 16.712 40.214 16.712 15.68 0 29.912-6.3606 40.221-16.626s16.697-24.433 16.699-40.046h-0.002v-76.824l-113.84-0.0203-0.0697 76.75m91.022-53.747 0.004 48.889-0.0423 5.1717h0.00088c0 1.3626-0.082 2.914-0.23988 4.2333-0.926 7.7311-4.481 14.467-9.7451 19.708-6.1636 6.1375-14.672 9.9413-24.047 9.9413-9.327 0-17.639-3.9379-23.829-10.1-6.3488-6.3182-10.029-14.984-10.029-23.945l-0.0132-54.023 67.941 0.12259",
    fillRule: "evenodd",
    fill: "#f00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path1435",
    d: "m182.82 211.12v0.045c0 15.557 6.4414 29.724 16.775 40.009 10.354 10.305 24.614 16.712 40.214 16.712 15.681 0 29.912-6.3606 40.222-16.626 10.308-10.265 16.697-24.433 16.699-40.044h-0.002v-76.826l-113.84-0.0185-0.0697 76.748m91.022-53.747 0.004 48.891-0.0414 5.1717h0.00088c0 1.3608-0.082 2.9122-0.24076 4.2333-0.92512 7.7294-4.4801 14.467-9.7451 19.708-6.1636 6.1357-14.671 9.9413-24.047 9.9413-9.327 0-17.639-3.9379-23.829-10.1-6.3497-6.32-10.03-14.986-10.03-23.947l-0.0132-54.023 67.94 0.12259 0.002 0.002z",
    stroke: "#000",
    strokeWidth: 0.50734,
    fill: "none"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "use3438",
    xlinkHref: "#use3436",
    transform: "translate(-20.745 -.040565)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "use3434",
    xlinkHref: "#path1485",
    transform: "translate(-.06747 51.8)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "use3440",
    xlinkHref: "#use3438",
    transform: "translate(-20.799 .05071)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "use3436",
    xlinkHref: "#use3434",
    transform: "translate(20.818 -25.743)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "path1485",
    fill: "#039",
    d: "m232.63 176.39v0.005c0 2.2119 0.84927 4.2272 2.2118 5.6894 1.3652 1.4667 3.2454 2.3777 5.302 2.3777 2.0672 0 3.9439-0.90487 5.3029-2.3654 1.3581-1.4587 2.2021-3.4722 2.2021-5.693v-10.768l-14.992-0.0123-0.0273 10.766"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6250"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use4364",
    xlinkHref: "#path1539",
    transform: "translate(10.608)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1497",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m190.19 154.43c0.13493-5.521 4.0524-6.828 4.0806-6.8474 0.0282-0.0185 4.2314 1.4076 4.2173 6.8986l-8.2978-0.0512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1499",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.81 147.68-0.68172 6.3465 4.1406 0.009c0.0397-5.2493 3.9748-6.1225 4.07-6.1031 0.0891-0.005 3.9889 1.1589 4.0929 6.1031h4.1511l-0.7505-6.3932-15.022 0.0379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1501",
    d: "m186.81 147.69-0.68172 6.3447 4.1406 0.009c0.0397-5.2493 3.9739-6.1225 4.0691-6.1031 0.0891-0.005 3.9889 1.1606 4.0929 6.1031h4.1511l-0.74962-6.3932-15.022 0.0379v0.002z",
    stroke: "#000",
    strokeWidth: 0.49936,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1503",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m185.85 154.06h16.946c0.35629 0 0.6482 0.35277 0.6482 0.78404 0 0.42863-0.29103 0.78141-0.6482 0.78141h-16.946c-0.35718 0-0.64909-0.35102-0.64909-0.78141 0-0.43127 0.29191-0.78404 0.64909-0.78404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1505",
    d: "m185.85 154.06h16.946c0.35717 0 0.64908 0.35277 0.64908 0.78404 0 0.43039-0.29191 0.78141-0.64908 0.78141h-16.946c-0.35717 0-0.64908-0.35102-0.64908-0.78141 0-0.43127 0.29191-0.78404 0.64908-0.78404z",
    stroke: "#000",
    strokeWidth: 0.49943,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1507",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m192.01 154.03c0.0185-3.3126 2.2621-4.2501 2.2736-4.2483 0.00088 0 2.3415 0.96661 2.36 4.2483h-4.6335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1509",
    d: "m192.01 154.03c0.0185-3.3126 2.2621-4.2501 2.2736-4.2483 0.00088 0 2.3423 0.96661 2.3609 4.2483h-4.6344",
    stroke: "#000",
    strokeWidth: 0.49703,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1511",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.21 145.06h16.245c0.34218 0 0.62263 0.31662 0.62263 0.70467 0 0.38541-0.28045 0.70468-0.62263 0.70468h-16.245c-0.34218 0-0.62263-0.3175-0.62263-0.70468 0-0.38805 0.28045-0.70467 0.62263-0.70467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1513",
    d: "m186.21 145.05h16.245c0.34218 0 0.62263 0.31839 0.62263 0.70468 0 0.38717-0.28045 0.70467-0.62263 0.70467h-16.245c-0.34218 0-0.62263-0.31573-0.62263-0.70467 0-0.38629 0.28045-0.70468 0.62263-0.70468z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1515",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.55 146.47h15.539c0.32719 0 0.59617 0.31662 0.59617 0.70379 0 0.38805-0.2681 0.70467-0.59617 0.70467h-15.539c-0.32719 0-0.59529-0.31662-0.59529-0.70467 0-0.38717 0.2681-0.70379 0.59529-0.70379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1517",
    d: "m186.55 146.47h15.538c0.32719 0 0.59529 0.31662 0.59529 0.70379 0 0.38805-0.2681 0.70467-0.59529 0.70467h-15.538c-0.32719 0-0.59529-0.31662-0.59529-0.70467 0-0.38717 0.2681-0.70379 0.59529-0.70379z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use4658",
    xlinkHref: "#use4656",
    transform: "translate(-5.2791 -3.1627)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1521",
    d: "m191.57 135.88 1.2267 0.002v0.87136h0.89513v-0.89076l1.2567 0.004v0.88723h0.89778v-0.89076h1.2576l-0.002 2.0117c0 0.31574-0.25398 0.52035-0.54854 0.52035h-4.4113c-0.29633 0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z",
    stroke: "#000",
    strokeWidth: 0.50025,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1523",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m196.19 138.57 0.27692 6.4532-4.3028-0.0159 0.28485-6.4506 3.7419 0.015"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1525",
    d: "m196.19 138.57 0.27691 6.4514-4.3028-0.0159 0.28486-6.4523 3.741 0.0168",
    stroke: "#000",
    strokeWidth: 0.49898,
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use4656",
    xlinkHref: "#path1535",
    transform: "translate(10.608)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("use", {
    id: "use4366",
    xlinkHref: "#path1541",
    transform: "translate(10.609)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("use", {
    id: "use4660",
    xlinkHref: "#path1537",
    transform: "translate(10.609 -.010585)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1535",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.3 139.04 1.2003 0.002v0.87136h0.87662v-0.89077l1.2294 0.004v0.88724h0.87926v-0.89077l1.2302 0.002-0.002 2.0117c0 0.31398-0.2487 0.51859-0.5362 0.51859h-4.3169c-0.29014 0-0.55824-0.23548-0.55824-0.52741l-0.002-1.987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1537",
    d: "m186.3 139.04 1.1994 0.003v0.87224h0.8775v-0.89253l1.2294 0.004v0.889h0.87926v-0.89253l1.2302 0.002-0.002 2.0117c0 0.31398-0.2487 0.51859-0.5362 0.51859h-4.3169c-0.28926 0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z",
    stroke: "#000",
    strokeWidth: 0.50017,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1539",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m190.94 141.56 0.13141 3.4775-4.1264 0.002 0.11641-3.4793h3.8786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1541",
    d: "m190.94 141.56 0.13141 3.4775-4.1256 0.002 0.11641-3.4793h3.8786-0.00089z",
    stroke: "#000",
    strokeWidth: 0.50128,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1543",
    fillRule: "evenodd",
    d: "m193.9 140.61c-0.0265-0.62706 0.87661-0.63411 0.86603 0v1.5364h-0.86603v-1.5364"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use4362",
    xlinkHref: "#path1547",
    transform: "translate(10.641)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1547",
    fillRule: "evenodd",
    d: "m188.57 142.84c-0.003-0.6059 0.83693-0.61824 0.82635 0v1.1871h-0.82635v-1.1871"
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    id: "use4984",
    xlinkHref: "#use4982",
    transform: "translate(-45.205)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    id: "use4982",
    xlinkHref: "#use4980",
    transform: "translate(90.919 -46.32)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "use4980",
    transform: "translate(0 46.32)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use5166",
    xlinkHref: "#path1539",
    transform: "translate(10.608)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5168",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m190.19 154.43c0.13493-5.521 4.0524-6.828 4.0806-6.8474 0.0282-0.0185 4.2314 1.4076 4.2173 6.8986l-8.2978-0.0512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5170",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.81 147.68-0.68172 6.3465 4.1406 0.009c0.0397-5.2493 3.9748-6.1225 4.07-6.1031 0.0891-0.005 3.9889 1.1589 4.0929 6.1031h4.1511l-0.7505-6.3932-15.022 0.0379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5172",
    d: "m186.81 147.69-0.68172 6.3447 4.1406 0.009c0.0397-5.2493 3.9739-6.1225 4.0691-6.1031 0.0891-0.005 3.9889 1.1606 4.0929 6.1031h4.1511l-0.74962-6.3932-15.022 0.0379v0.002z",
    stroke: "#000",
    strokeWidth: 0.49936,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5174",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m185.85 154.06h16.946c0.35629 0 0.6482 0.35277 0.6482 0.78404 0 0.42863-0.29103 0.78141-0.6482 0.78141h-16.946c-0.35718 0-0.64909-0.35102-0.64909-0.78141 0-0.43127 0.29191-0.78404 0.64909-0.78404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5176",
    d: "m185.85 154.06h16.946c0.35717 0 0.64908 0.35277 0.64908 0.78404 0 0.43039-0.29191 0.78141-0.64908 0.78141h-16.946c-0.35717 0-0.64908-0.35102-0.64908-0.78141 0-0.43127 0.29191-0.78404 0.64908-0.78404z",
    stroke: "#000",
    strokeWidth: 0.49943,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5178",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m192.01 154.03c0.0185-3.3126 2.2621-4.2501 2.2736-4.2483 0.00088 0 2.3415 0.96661 2.36 4.2483h-4.6335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5180",
    d: "m192.01 154.03c0.0185-3.3126 2.2621-4.2501 2.2736-4.2483 0.00088 0 2.3423 0.96661 2.3609 4.2483h-4.6344",
    stroke: "#000",
    strokeWidth: 0.49703,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5182",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.21 145.06h16.245c0.34218 0 0.62263 0.31662 0.62263 0.70467 0 0.38541-0.28045 0.70468-0.62263 0.70468h-16.245c-0.34218 0-0.62263-0.3175-0.62263-0.70468 0-0.38805 0.28045-0.70467 0.62263-0.70467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5184",
    d: "m186.21 145.05h16.245c0.34218 0 0.62263 0.31839 0.62263 0.70468 0 0.38717-0.28045 0.70467-0.62263 0.70467h-16.245c-0.34218 0-0.62263-0.31573-0.62263-0.70467 0-0.38629 0.28045-0.70468 0.62263-0.70468z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5186",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.55 146.47h15.539c0.32719 0 0.59617 0.31662 0.59617 0.70379 0 0.38805-0.2681 0.70467-0.59617 0.70467h-15.539c-0.32719 0-0.59529-0.31662-0.59529-0.70467 0-0.38717 0.2681-0.70379 0.59529-0.70379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5188",
    d: "m186.55 146.47h15.538c0.32719 0 0.59529 0.31662 0.59529 0.70379 0 0.38805-0.2681 0.70467-0.59529 0.70467h-15.538c-0.32719 0-0.59529-0.31662-0.59529-0.70467 0-0.38717 0.2681-0.70379 0.59529-0.70379z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5190",
    xlinkHref: "#use4656",
    transform: "translate(-5.2791 -3.1627)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5192",
    d: "m191.57 135.88 1.2267 0.002v0.87136h0.89513v-0.89076l1.2567 0.004v0.88723h0.89778v-0.89076h1.2576l-0.002 2.0117c0 0.31574-0.25398 0.52035-0.54854 0.52035h-4.4113c-0.29633 0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z",
    stroke: "#000",
    strokeWidth: 0.50025,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5194",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m196.19 138.57 0.27692 6.4532-4.3028-0.0159 0.28485-6.4506 3.7419 0.015"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5196",
    d: "m196.19 138.57 0.27691 6.4514-4.3028-0.0159 0.28486-6.4523 3.741 0.0168",
    stroke: "#000",
    strokeWidth: 0.49898,
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5198",
    xlinkHref: "#path1535",
    transform: "translate(10.608)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5200",
    xlinkHref: "#path1541",
    transform: "translate(10.609)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5202",
    xlinkHref: "#path1537",
    transform: "translate(10.609 -.010585)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5204",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.3 139.04 1.2003 0.002v0.87136h0.87662v-0.89077l1.2294 0.004v0.88724h0.87926v-0.89077l1.2302 0.002-0.002 2.0117c0 0.31398-0.2487 0.51859-0.5362 0.51859h-4.3169c-0.29014 0-0.55824-0.23548-0.55824-0.52741l-0.002-1.987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5206",
    d: "m186.3 139.04 1.1994 0.003v0.87224h0.8775v-0.89253l1.2294 0.004v0.889h0.87926v-0.89253l1.2302 0.002-0.002 2.0117c0 0.31398-0.2487 0.51859-0.5362 0.51859h-4.3169c-0.28926 0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z",
    stroke: "#000",
    strokeWidth: 0.50017,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5208",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m190.94 141.56 0.13141 3.4775-4.1264 0.002 0.11641-3.4793h3.8786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5210",
    d: "m190.94 141.56 0.13141 3.4775-4.1256 0.002 0.11641-3.4793h3.8786-0.00089z",
    stroke: "#000",
    strokeWidth: 0.50128,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5212",
    fillRule: "evenodd",
    d: "m193.9 140.61c-0.0265-0.62706 0.87661-0.63411 0.86603 0v1.5364h-0.86603v-1.5364"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5214",
    xlinkHref: "#path1547",
    transform: "translate(10.641)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5216",
    fillRule: "evenodd",
    d: "m188.57 142.84c-0.003-0.6059 0.83693-0.61824 0.82635 0v1.1871h-0.82635v-1.1871"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "use5132",
    transform: "matrix(.70711 .70711 -.70711 .70711 240.44 -.49531)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use5328",
    xlinkHref: "#path1539",
    transform: "translate(10.608)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5330",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m190.19 154.43c0.13493-5.521 4.0524-6.828 4.0806-6.8474 0.0282-0.0185 4.2314 1.4076 4.2173 6.8986l-8.2978-0.0512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5332",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.81 147.68-0.68172 6.3465 4.1406 0.009c0.0397-5.2493 3.9748-6.1225 4.07-6.1031 0.0891-0.005 3.9889 1.1589 4.0929 6.1031h4.1511l-0.7505-6.3932-15.022 0.0379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5334",
    d: "m186.81 147.69-0.68172 6.3447 4.1406 0.009c0.0397-5.2493 3.9739-6.1225 4.0691-6.1031 0.0891-0.005 3.9889 1.1606 4.0929 6.1031h4.1511l-0.74962-6.3932-15.022 0.0379v0.002z",
    stroke: "#000",
    strokeWidth: 0.49936,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5336",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m185.85 154.06h16.946c0.35629 0 0.6482 0.35277 0.6482 0.78404 0 0.42863-0.29103 0.78141-0.6482 0.78141h-16.946c-0.35718 0-0.64909-0.35102-0.64909-0.78141 0-0.43127 0.29191-0.78404 0.64909-0.78404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5338",
    d: "m185.85 154.06h16.946c0.35717 0 0.64908 0.35277 0.64908 0.78404 0 0.43039-0.29191 0.78141-0.64908 0.78141h-16.946c-0.35717 0-0.64908-0.35102-0.64908-0.78141 0-0.43127 0.29191-0.78404 0.64908-0.78404z",
    stroke: "#000",
    strokeWidth: 0.49943,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5340",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m192.01 154.03c0.0185-3.3126 2.2621-4.2501 2.2736-4.2483 0.00088 0 2.3415 0.96661 2.36 4.2483h-4.6335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5342",
    d: "m192.01 154.03c0.0185-3.3126 2.2621-4.2501 2.2736-4.2483 0.00088 0 2.3423 0.96661 2.3609 4.2483h-4.6344",
    stroke: "#000",
    strokeWidth: 0.49703,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5344",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.21 145.06h16.245c0.34218 0 0.62263 0.31662 0.62263 0.70467 0 0.38541-0.28045 0.70468-0.62263 0.70468h-16.245c-0.34218 0-0.62263-0.3175-0.62263-0.70468 0-0.38805 0.28045-0.70467 0.62263-0.70467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5346",
    d: "m186.21 145.05h16.245c0.34218 0 0.62263 0.31839 0.62263 0.70468 0 0.38717-0.28045 0.70467-0.62263 0.70467h-16.245c-0.34218 0-0.62263-0.31573-0.62263-0.70467 0-0.38629 0.28045-0.70468 0.62263-0.70468z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5348",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.55 146.47h15.539c0.32719 0 0.59617 0.31662 0.59617 0.70379 0 0.38805-0.2681 0.70467-0.59617 0.70467h-15.539c-0.32719 0-0.59529-0.31662-0.59529-0.70467 0-0.38717 0.2681-0.70379 0.59529-0.70379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5350",
    d: "m186.55 146.47h15.538c0.32719 0 0.59529 0.31662 0.59529 0.70379 0 0.38805-0.2681 0.70467-0.59529 0.70467h-15.538c-0.32719 0-0.59529-0.31662-0.59529-0.70467 0-0.38717 0.2681-0.70379 0.59529-0.70379z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5352",
    xlinkHref: "#use4656",
    transform: "translate(-5.2791 -3.1627)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5354",
    d: "m191.57 135.88 1.2267 0.002v0.87136h0.89513v-0.89076l1.2567 0.004v0.88723h0.89778v-0.89076h1.2576l-0.002 2.0117c0 0.31574-0.25398 0.52035-0.54854 0.52035h-4.4113c-0.29633 0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z",
    stroke: "#000",
    strokeWidth: 0.50025,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5356",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m196.19 138.57 0.27692 6.4532-4.3028-0.0159 0.28485-6.4506 3.7419 0.015"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5358",
    d: "m196.19 138.57 0.27691 6.4514-4.3028-0.0159 0.28486-6.4523 3.741 0.0168",
    stroke: "#000",
    strokeWidth: 0.49898,
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5360",
    xlinkHref: "#path1535",
    transform: "translate(10.608)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5362",
    xlinkHref: "#path1541",
    transform: "translate(10.609)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5364",
    xlinkHref: "#path1537",
    transform: "translate(10.609 -.010585)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5366",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.3 139.04 1.2003 0.002v0.87136h0.87662v-0.89077l1.2294 0.004v0.88724h0.87926v-0.89077l1.2302 0.002-0.002 2.0117c0 0.31398-0.2487 0.51859-0.5362 0.51859h-4.3169c-0.29014 0-0.55824-0.23548-0.55824-0.52741l-0.002-1.987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5368",
    d: "m186.3 139.04 1.1994 0.003v0.87224h0.8775v-0.89253l1.2294 0.004v0.889h0.87926v-0.89253l1.2302 0.002-0.002 2.0117c0 0.31398-0.2487 0.51859-0.5362 0.51859h-4.3169c-0.28926 0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z",
    stroke: "#000",
    strokeWidth: 0.50017,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5370",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m190.94 141.56 0.13141 3.4775-4.1264 0.002 0.11641-3.4793h3.8786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5372",
    d: "m190.94 141.56 0.13141 3.4775-4.1256 0.002 0.11641-3.4793h3.8786-0.00089z",
    stroke: "#000",
    strokeWidth: 0.50128,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5374",
    fillRule: "evenodd",
    d: "m193.9 140.61c-0.0265-0.62706 0.87661-0.63411 0.86603 0v1.5364h-0.86603v-1.5364"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5376",
    xlinkHref: "#path1547",
    transform: "translate(10.641)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5378",
    fillRule: "evenodd",
    d: "m188.57 142.84c-0.003-0.6059 0.83693-0.61824 0.82635 0v1.1871h-0.82635v-1.1871"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "use5100",
    transform: "translate(90.85 46.321)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use5220",
    xlinkHref: "#path1539",
    transform: "translate(10.608)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5222",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m190.19 154.43c0.13493-5.521 4.0524-6.828 4.0806-6.8474 0.0282-0.0185 4.2314 1.4076 4.2173 6.8986l-8.2978-0.0512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5224",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.81 147.68-0.68172 6.3465 4.1406 0.009c0.0397-5.2493 3.9748-6.1225 4.07-6.1031 0.0891-0.005 3.9889 1.1589 4.0929 6.1031h4.1511l-0.7505-6.3932-15.022 0.0379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5226",
    d: "m186.81 147.69-0.68172 6.3447 4.1406 0.009c0.0397-5.2493 3.9739-6.1225 4.0691-6.1031 0.0891-0.005 3.9889 1.1606 4.0929 6.1031h4.1511l-0.74962-6.3932-15.022 0.0379v0.002z",
    stroke: "#000",
    strokeWidth: 0.49936,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5228",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m185.85 154.06h16.946c0.35629 0 0.6482 0.35277 0.6482 0.78404 0 0.42863-0.29103 0.78141-0.6482 0.78141h-16.946c-0.35718 0-0.64909-0.35102-0.64909-0.78141 0-0.43127 0.29191-0.78404 0.64909-0.78404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5230",
    d: "m185.85 154.06h16.946c0.35717 0 0.64908 0.35277 0.64908 0.78404 0 0.43039-0.29191 0.78141-0.64908 0.78141h-16.946c-0.35717 0-0.64908-0.35102-0.64908-0.78141 0-0.43127 0.29191-0.78404 0.64908-0.78404z",
    stroke: "#000",
    strokeWidth: 0.49943,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5232",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m192.01 154.03c0.0185-3.3126 2.2621-4.2501 2.2736-4.2483 0.00088 0 2.3415 0.96661 2.36 4.2483h-4.6335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5234",
    d: "m192.01 154.03c0.0185-3.3126 2.2621-4.2501 2.2736-4.2483 0.00088 0 2.3423 0.96661 2.3609 4.2483h-4.6344",
    stroke: "#000",
    strokeWidth: 0.49703,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5236",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.21 145.06h16.245c0.34218 0 0.62263 0.31662 0.62263 0.70467 0 0.38541-0.28045 0.70468-0.62263 0.70468h-16.245c-0.34218 0-0.62263-0.3175-0.62263-0.70468 0-0.38805 0.28045-0.70467 0.62263-0.70467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5238",
    d: "m186.21 145.05h16.245c0.34218 0 0.62263 0.31839 0.62263 0.70468 0 0.38717-0.28045 0.70467-0.62263 0.70467h-16.245c-0.34218 0-0.62263-0.31573-0.62263-0.70467 0-0.38629 0.28045-0.70468 0.62263-0.70468z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5240",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.55 146.47h15.539c0.32719 0 0.59617 0.31662 0.59617 0.70379 0 0.38805-0.2681 0.70467-0.59617 0.70467h-15.539c-0.32719 0-0.59529-0.31662-0.59529-0.70467 0-0.38717 0.2681-0.70379 0.59529-0.70379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5242",
    d: "m186.55 146.47h15.538c0.32719 0 0.59529 0.31662 0.59529 0.70379 0 0.38805-0.2681 0.70467-0.59529 0.70467h-15.538c-0.32719 0-0.59529-0.31662-0.59529-0.70467 0-0.38717 0.2681-0.70379 0.59529-0.70379z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5244",
    xlinkHref: "#use4656",
    transform: "translate(-5.2791 -3.1627)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5246",
    d: "m191.57 135.88 1.2267 0.002v0.87136h0.89513v-0.89076l1.2567 0.004v0.88723h0.89778v-0.89076h1.2576l-0.002 2.0117c0 0.31574-0.25398 0.52035-0.54854 0.52035h-4.4113c-0.29633 0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z",
    stroke: "#000",
    strokeWidth: 0.50025,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5248",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m196.19 138.57 0.27692 6.4532-4.3028-0.0159 0.28485-6.4506 3.7419 0.015"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5250",
    d: "m196.19 138.57 0.27691 6.4514-4.3028-0.0159 0.28486-6.4523 3.741 0.0168",
    stroke: "#000",
    strokeWidth: 0.49898,
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5252",
    xlinkHref: "#path1535",
    transform: "translate(10.608)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5254",
    xlinkHref: "#path1541",
    transform: "translate(10.609)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5256",
    xlinkHref: "#path1537",
    transform: "translate(10.609 -.010585)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5258",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m186.3 139.04 1.2003 0.002v0.87136h0.87662v-0.89077l1.2294 0.004v0.88724h0.87926v-0.89077l1.2302 0.002-0.002 2.0117c0 0.31398-0.2487 0.51859-0.5362 0.51859h-4.3169c-0.29014 0-0.55824-0.23548-0.55824-0.52741l-0.002-1.987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5260",
    d: "m186.3 139.04 1.1994 0.003v0.87224h0.8775v-0.89253l1.2294 0.004v0.889h0.87926v-0.89253l1.2302 0.002-0.002 2.0117c0 0.31398-0.2487 0.51859-0.5362 0.51859h-4.3169c-0.28926 0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z",
    stroke: "#000",
    strokeWidth: 0.50017,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5262",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m190.94 141.56 0.13141 3.4775-4.1264 0.002 0.11641-3.4793h3.8786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5264",
    d: "m190.94 141.56 0.13141 3.4775-4.1256 0.002 0.11641-3.4793h3.8786-0.00089z",
    stroke: "#000",
    strokeWidth: 0.50128,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5266",
    fillRule: "evenodd",
    d: "m193.9 140.61c-0.0265-0.62706 0.87661-0.63411 0.86603 0v1.5364h-0.86603v-1.5364"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use5268",
    xlinkHref: "#path1547",
    transform: "translate(10.641)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5270",
    fillRule: "evenodd",
    d: "m188.57 142.84c-0.003-0.6059 0.83693-0.61824 0.82635 0v1.1871h-0.82635v-1.1871"
  }))), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    id: "use5274",
    xlinkHref: "#path1539",
    transform: "matrix(.70711 -.70711 .70711 .70711 -27.965 266.76)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "path5276",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m208.22 248.98c-3.8085-3.9993-1.9627-7.6936-1.9565-7.7273 0.007-0.0331 3.9874-1.9967 7.8601 1.896l-5.9036 5.8313"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "path5278",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m201.06 246.59 4.0056 4.9697 2.934-2.9216c-3.6838-3.7399-1.5187-7.1398-1.4376-7.1934 0.0592-0.0667 3.64-2.0011 7.2096 1.4214l2.9353-2.9353-5.0514-3.99-10.595 10.649"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path5280",
    d: "m201.06 246.6 4.0043 4.9684 2.934-2.9216c-3.6838-3.7399-1.5193-7.1392-1.4382-7.1928 0.0592-0.0667 3.6412-1.9999 7.2096 1.4214l2.9353-2.9353-5.0508-3.9906-10.596 10.649 0.001 0.001z",
    stroke: "#000",
    strokeWidth: 0.49936,
    fill: "none"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "path5282",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m204.89 251.78 11.982-11.983c0.25194-0.25193 0.70779-0.2089 1.0128 0.0961 0.30309 0.30308 0.34675 0.75832 0.0942 1.0109l-11.982 11.983c-0.25257 0.25256-0.70719 0.21076-1.0115-0.0936-0.30495-0.30495-0.34799-0.76081-0.0954-1.0134"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "path5284",
    d: "m204.89 251.78 11.983-11.983c0.25256-0.25255 0.70841-0.20952 1.0134 0.0954 0.30433 0.30433 0.34613 0.75895 0.0936 1.0115l-11.983 11.983c-0.25256 0.25255-0.70718 0.21076-1.0115-0.0936-0.30496-0.30495-0.34799-0.76081-0.0954-1.0134z",
    stroke: "#000",
    strokeWidth: 0.49943,
    fill: "none"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "path5286",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m209.22 247.4c-2.3293-2.3554-1.4057-4.6048-1.3964-4.6117 0.00062-0.00062 2.3392-0.97216 4.6728 1.3353l-3.2764 3.2764"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "path5288",
    d: "m209.22 247.4c-2.3293-2.3554-1.4057-4.6048-1.3964-4.6117 0.00062-0.00062 2.3398-0.97279 4.6734 1.3346l-3.277 3.277",
    stroke: "#000",
    strokeWidth: 0.49703,
    fill: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "path5290",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m198.77 245.16 11.487-11.487c0.24195-0.24196 0.66415-0.21638 0.93854 0.058 0.27252 0.27253 0.29997 0.69659 0.058 0.93855l-11.487 11.487c-0.24196 0.24196-0.66477 0.21576-0.93855-0.058-0.27439-0.27439-0.29997-0.69658-0.058-0.93854"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "path5292",
    d: "m198.77 245.16 11.487-11.487c0.24196-0.24196 0.66541-0.21513 0.93855 0.058 0.27377 0.27377 0.29997 0.69658 0.058 0.93854l-11.487 11.487c-0.24196 0.24195-0.66352 0.21701-0.93855-0.058-0.27314-0.27315-0.29997-0.6966-0.058-0.93855z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "path5294",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m200.01 245.91 10.988-10.988c0.23136-0.23136 0.64544-0.19767 0.91921 0.0761 0.27439 0.27439 0.3087 0.68785 0.0767 0.91983l-10.988 10.988c-0.23136 0.23136-0.64482 0.19705-0.91921-0.0773-0.27377-0.27377-0.30808-0.68723-0.0767-0.91859"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "path5296",
    d: "m200.01 245.91 10.987-10.987c0.23135-0.23136 0.64481-0.19705 0.91858 0.0767 0.2744 0.27439 0.30871 0.68785 0.0773 0.91921l-10.987 10.987c-0.23136 0.23136-0.64482 0.19705-0.91921-0.0773-0.27377-0.27377-0.30808-0.68723-0.0767-0.91859z",
    stroke: "#000",
    strokeWidth: 0.49901,
    fill: "none"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    id: "use5298",
    xlinkHref: "#use4656",
    transform: "matrix(.70711 -.70711 .70711 .70711 -41.435 275.76)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "path5300",
    d: "m196.08 234.88 0.86868-0.86618 0.61614 0.61614 0.63295-0.63295-0.62986-0.62986 0.89113-0.88614 0.62737 0.62736 0.63482-0.63482-0.62986-0.62986 0.88926-0.88926 1.4212 1.4237c0.22326 0.22327 0.18835 0.54754-0.0199 0.75582l-3.1193 3.1193c-0.20953 0.20953-0.5706 0.2351-0.77578 0.0312l-1.4075-1.4038 0.00062-0.00062z",
    stroke: "#000",
    strokeWidth: 0.50025,
    fill: "none"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "path5302",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m201.25 233.51 4.7589 4.3673-3.0538 3.0313-4.3598-4.7626 2.6565-2.6353"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "path5304",
    d: "m201.25 233.52 4.7576 4.366-3.0538 3.0313-4.361-4.7639 2.6572-2.6335",
    stroke: "#000",
    strokeWidth: 0.49898,
    fill: "none"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    id: "use5306",
    xlinkHref: "#path1535",
    transform: "matrix(.70711 -.70711 .70711 .70711 -27.965 266.76)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    id: "use5308",
    xlinkHref: "#path1541",
    transform: "matrix(.70711 -.70711 .70711 .70711 -27.965 266.76)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    id: "use5310",
    xlinkHref: "#path1537",
    transform: "matrix(.70711 -.70711 .70711 .70711 -27.972 266.75)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "path5312",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m194.59 240.84 0.84997-0.84747 0.61615 0.61614 0.61986-0.61986-0.62987-0.62987 0.8718-0.86681 0.62737 0.62738 0.62173-0.62174-0.62987-0.62986 0.87117-0.86867 1.4212 1.4237c0.22202 0.22201 0.19084 0.54255-0.0125 0.74585l-3.0525 3.0525c-0.20516 0.20516-0.56124 0.22822-0.76767 0.0218l-1.4063-1.4038"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "path5314",
    d: "m194.59 240.84 0.84997-0.84623 0.61677 0.61677 0.62048-0.62049-0.63111-0.63111 0.8718-0.86681 0.62862 0.62862 0.62173-0.62173-0.63112-0.63111 0.87117-0.86867 1.4212 1.4237c0.22202 0.22201 0.19084 0.54255-0.0125 0.74585l-3.0525 3.0525c-0.20454 0.20453-0.56124 0.22822-0.76705 0.0237l-1.4082-1.4044 0.00062-0.00062z",
    stroke: "#000",
    strokeWidth: 0.50017,
    fill: "none"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "path5316",
    fillRule: "evenodd",
    fill: "#ff0",
    d: "m199.65 239.34 2.5519 2.366-2.9166 2.9191-2.3779-2.5425 2.7426-2.7426"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "path5318",
    d: "m199.65 239.34 2.5519 2.366-2.916 2.9184-2.3779-2.5425 2.7426-2.7426-0.00063 0.00063z",
    stroke: "#000",
    strokeWidth: 0.50128,
    fill: "none"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "path5320",
    fillRule: "evenodd",
    d: "m201.07 236.58c-0.46211-0.42469 0.17147-1.0682 0.61237-0.61237l1.0864 1.0864-0.61238 0.61237-1.0864-1.0864"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    id: "use5322",
    xlinkHref: "#path1547",
    transform: "matrix(.70711 -.70711 .70711 .70711 -27.942 266.74)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "path5324",
    fillRule: "evenodd",
    d: "m198.88 241.93c-0.4303-0.42657 0.15464-1.029 0.58432-0.58432l0.8394 0.83941-0.58431 0.58431-0.83941-0.8394"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    id: "use6358",
    xlinkHref: "#use5944",
    transform: "translate(-20.819 25.744)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    id: "use6360",
    xlinkHref: "#use5944",
    transform: "translate(-29.056 25.754)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    id: "use6356",
    xlinkHref: "#use5944",
    transform: "translate(-24.976 21.575)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    id: "use6352",
    xlinkHref: "#use5944",
    transform: "translate(-20.81 17.581)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "use5944",
    fill: "#fff",
    d: "m265.13 202.46c-0.8184 0-1.486 0.66676-1.486 1.4852 0 0.81669 0.66761 1.4852 1.486 1.4852 0.81841 0 1.486-0.66675 1.486-1.4852 0-0.81844-0.66761-1.4852-1.486-1.4852"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    id: "use5946",
    xlinkHref: "#use5944",
    transform: "translate(-8.1127 .012345)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    id: "use5948",
    xlinkHref: "#use5946",
    transform: "translate(3.9554 -4.18)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    id: "use5950",
    xlinkHref: "#use5948",
    transform: "translate(4.1661 -3.9948)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    id: "use5952",
    xlinkHref: "#use5950",
    transform: "translate(-8.1391 -.00705)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    id: "use5954",
    xlinkHref: "#use5952",
    transform: "translate(-12.617 8.1298)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    id: "use5956",
    xlinkHref: "#use5954",
    transform: "translate(-8.3089 .010585)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    id: "use5958",
    xlinkHref: "#use5956",
    transform: "translate(4.1516 -4.1809)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    id: "use5960",
    xlinkHref: "#use5958",
    transform: "translate(4.167 -3.993)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    id: "use5962",
    xlinkHref: "#use5960",
    transform: "translate(-8.3186 -.007495)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    id: "use5964",
    xlinkHref: "#use5962",
    transform: "translate(-12.489 8.2228)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    id: "use5966",
    xlinkHref: "#use5964",
    transform: "translate(-8.1127 .010145)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    id: "use5968",
    xlinkHref: "#use5966",
    transform: "translate(3.9554 -4.18)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    id: "use5970",
    xlinkHref: "#use5968",
    transform: "translate(4.167 -3.9934)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    id: "use6354",
    xlinkHref: "#use5944",
    transform: "translate(-29.056 17.574)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "use6320",
    fill: "#ff0",
    d: "m215.45 194.3c-0.81839 0-1.486 0.66675-1.486 1.4852 0 0.81668 0.66762 1.4852 1.486 1.4852 0.81841 0 1.486-0.66675 1.486-1.4852s-0.66761-1.4852-1.486-1.4852"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    id: "use6346",
    xlinkHref: "#use5944",
    transform: "translate(-29.056 -34.226)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    id: "use6332",
    xlinkHref: "#use5944",
    transform: "translate(-20.917 -34.226)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    id: "use6334",
    xlinkHref: "#use5944",
    transform: "translate(-25.084 -30.225)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    id: "use6336",
    xlinkHref: "#use5944",
    transform: "translate(-20.925 -26.056)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    id: "use6338",
    xlinkHref: "#use5944",
    transform: "translate(-29.056 -26.045)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    id: "use6340",
    xlinkHref: "#use5944",
    transform: "translate(-49.674 -8.158)",
    height: 400,
    width: 600,
    y: 0,
    x: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.cb1c83a063c2d4cfd7c8343b162d4dcf.svg";
export { ForwardRef as ReactComponent };